import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch, useDoorContent } from 'shared/hooks';
import { PREDICTIONS } from './constants';
import { selectPrediction } from 'shared/selectors/prediction';
import { setPredictionVisible } from 'shared/slices';
import { Prediction } from 'shared/components/Prediction';
import { EAdventDoorsHashs } from 'shared/types/doors';

export const PredictionContainer: React.FC = () => {
  const { handleClickBtn, isLoading } = useDoorContent({
    doorCode: EAdventDoorsHashs.FifthDoor,
  });

  const predictionVisible = useSelector(selectPrediction);

  const dispatch = useAppDispatch();

  const randomPrediction = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * PREDICTIONS.length);

    return PREDICTIONS[randomIndex];
  }, []);

  const handleCloseOverlay = useCallback(() => {
    dispatch(setPredictionVisible(false));
  }, [dispatch]);

  const handleClosePrediction = useCallback(async () => {
    await handleClickBtn();

    handleCloseOverlay();
  }, [handleClickBtn, handleCloseOverlay]);

  if (!predictionVisible) {
    return null;
  }

  return (
    <Prediction
      onCloseOverlay={handleCloseOverlay}
      isLoading={isLoading}
      onClose={handleClosePrediction}
      prediction={randomPrediction}
    />
  );
};
